import env from 'utils/env';
import { flattenProductArray } from 'utils/apiMiddleware/apiMiddleware';
import request from './request';

export function createCampaign(formData) {
  const requestUrl = `${env.aceApi}/1/campaigns`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
}

export function updateCampaign(formData) {
  const requestUrl = `${env.aceApi}/1/campaigns`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'PUT',
    { 'Content-Type': 'application/json' },
    data
  );
}

export const getCampaigns = () => request(`${env.aceApi}/1/campaigns/all`);

export const getProductsByCampaignId = async (id) => {
  const response = await request(
    `${env.aceApi}/1/campaigns/${id}/product-bundles?orderBy=DEFAULT`,
    `GET`,
    { Accept: 'application/vnd.fabfitfun.v2+json' }
  );
  const {
    data: { items },
  } = response;
  const variants = flattenProductArray(items);
  return { products: items, variants };
};

export const updateProducts = async (campaignId, productsToUpdate) => {
  const requestUrl = `${env.aceApi}/1/campaigns/${campaignId}/product-bundles`;
  const data = JSON.stringify(productsToUpdate);
  const response = await request(
    requestUrl,
    'PUT',
    { 'Content-Type': 'application/json' },
    data
  );
  const variants = response.success ? flattenProductArray(response.value) : [];
  const error = response.success ? '' : response.message;
  return { updatedProducts: response.value, variants, error };
};

export function postSkusToCampaign(id, formData) {
  const requestUrl = `${env.aceApi}/1/campaigns/${id}/skus`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
}

export function setDefaultCampaign(campaignId) {
  const requestUrl = `${env.aceApi}/1/campaigns/${campaignId}/default?override=true`;
  return request(requestUrl, 'POST', {}, {});
}

export function deleteProductCacheByCampaignId(campaignId) {
  const requestUrl = `${env.aceApi}/1/campaigns/${campaignId}/cache`;
  return request(requestUrl, 'DELETE', {}, {});
}
